<template>
  <div class="tags-list is-unselectable" :class="{ 'tags-list--dark': dark }">
    <div class="level is-mobile">
      <div class="level-item-left">
        <icon name="fa-tags" />
        <span class="tags-list__category">Tagi</span>
      </div>
      <div class="level-item-right">
        <transition name="fade">
          <icon
            class="clear-tags"
            name="fa-trash"
            @click="$emit('clear-selected-tags')"
            v-if="selectedOneTagAtLeast"
          />
        </transition>
      </div>
    </div>
    <transition-group name="flip-list" tag="div" class="tags-container">
      <div
        class="is-unselectable video-tag"
        :class="{ 'video-tag--selected': tag.selected }"
        v-for="tag in tags"
        :key="tag.id"
        @click="$emit('toggle-tag-selection', tag)"
      >
        {{ tag.name }}
      </div>
    </transition-group>
  </div>
</template>

<script>
import { Icon } from "%helpers";

export default {
  name: "tags-list",

  components: {
    Icon
  },

  props: {
    tags: Array,
    dark: Boolean
  },

  computed: {
    selectedOneTagAtLeast() {
      return this.tags.some(tag => tag.selected);
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-list {
  &__category {
    font-family: $family-sans-serif-condensed;
    text-transform: uppercase;
    font-weight: 900;
    font-size: 0.9rem;
    margin-left: 0.5rem;
  }
}

.clear-tags {
  cursor: pointer;

  &:hover {
    color: $danger;
  }
}

.tags-container {
  display: flex;
  color: $grey;

  @include mobile {
    flex-wrap: wrap;
  }

  @include from($tablet) {
    flex-direction: column;
  }
}

.video-tag {
  cursor: pointer;
  position: relative;
  font-family: $family-sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.05rem;

  @include mobile {
    display: inline-block;
    padding: 0.7rem 1rem;
    border-radius: $radius-small;
    margin: 0.3rem 0.3rem;
    flex: 1;
    background: $grey-lighter;
    color: $grey;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &--selected {
      background: $primary;
      color: $white;
    }
  }

  @include from($tablet) {
    padding: 0.5rem 0 0.1rem 0.5rem;

    &:hover:before {
      position: absolute;
      left: -0.7rem;
      font-family: "Font Awesome 5 Pro";
      font-weight: 700;
      content: "\f067";
    }

    &:hover {
      color: $grey-dark;
    }

    &--selected:hover:before {
      position: absolute;
      left: -0.7rem;
      font-family: "Font Awesome 5 Pro";
      font-weight: 700;
      content: "\f068";
    }

    &--selected {
      color: $primary;
    }

    &--selected:hover {
      color: $link;
    }
  }
}

.tags-list--dark {
  .tags-container {
    .video-tag {
      @include from($tablet) {
        &:hover {
          color: $grey-light;
        }

        &--selected:hover {
          color: $link;
        }
      }

      @include mobile {
        background: $grey-dark;
        color: $grey;

        &--selected {
          background: $primary;
          color: $white;
        }
      }
    }
  }
}
</style>
